/**
 * This is the main entry point into our application.
 *
 * @class App
 */
import { isTargetModule } from './helpers/is_target_module';
import { Basket } from './sections/basket';
import { Checkout } from './sections/checkout';
import { Global } from './sections/global';
import { Posts } from './sections/posts';

declare global {
  interface Window {
    app: App;
  }
}

class App {
  public modules: { [className: string]: any } = {};

  /**
   * Creates an instance of App. We assign this instance to the window so
   *
   * @memberof App
   */
  constructor() {
    window.app = this;
  }

  /**
   * Loops through our modules, and executes it if required
   *
   * @memberof App
   */
  loadModules(targetModule: string): void {
    const modules = [Global, Basket, Checkout, Posts];
    window.loadModule = targetModule;
    modules.forEach((module) => {
      if (isTargetModule(module.id)) {
        new module();
      }
    });
  }
}

window.app = new App();
